import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

/* ─── Pantallas ES ──────────────────────────────────── */
import ItineraryAdmin from './screens/itineraryAdmin';
import MapView        from './screens/MapView';
import AñadirPOI      from './screens/añadirPOI';
import EliminarPOI    from './screens/eliminarPOI';
import { ItineraryProvider } from './context/ItineraryContext';


/* ─── Leaflet / MarkerCluster CSS ───────────────────── */
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster';

const App: React.FC = () => (
  <Router>
    {/* ---------- Español ---------- */}
    <ItineraryProvider>
      <Routes>
        <Route path="/"                     element={<ItineraryAdmin />} />
        {/* 👉 nueva ruta para los enlaces compartidos */}
        <Route path="/map/share/:shareId"   element={<MapView />} />
        <Route path="/map"                  element={<MapView />} />
        <Route path="/screens/añadirPOI"    element={<AñadirPOI />} />
        <Route path="/screens/eliminarPOI"  element={<EliminarPOI />} />
      </Routes>
    </ItineraryProvider>

    {/* ---------- English ---------- */}
 
  </Router>
);

export default App;
